import React, { useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import BrandkitSection from '../../../../../TldrSettings/TldrBrandKits/BrandkitSection';
import { useSelector } from "react-redux";

const EditBrandkitModal = (props) => {
  const { isOpen, onClose, brandkit } = props;
  const { title } = brandkit;

  const selectedBrandkit = useSelector((state) => state.brandKit.selectedBrandkit);

  useEffect(() => {

  }, [
    selectedBrandkit
  ]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
      size="2xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit {title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <BrandkitSection
            brandKitInfo={brandkit}
            fetchBrandkits={false}
            assetsDropzoneClassName="tldr-assets-dropzone"
            fontsDropzoneClassName="tldr-fonts-dropzone"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default EditBrandkitModal;